module.exports = __webpack_public_path__ + "img/about-check-in.c5ab99bc.png";